// client/src/components/modals/LinkVehicleModal.js
import React, { useState } from 'react';
import { Modal, Button, Form, Spinner, Alert, ListGroup } from 'react-bootstrap';
import api from '../../api/axios'; // Use centralized api instance

const LinkVehicleModal = ({ show, onHide, customerId, onSuccess }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [selectedVehicles, setSelectedVehicles] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState('');

    const handleSearchChange = async (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        if (term.length < 2) {
            setSearchResults([]);
            return;
        }
        setIsSearching(true);
        try {
            const response = await api.get('/vehicles/search-unlinked', { params: { term } });
            // Filter out already selected vehicles
            const newResults = response.data.data.filter(
                result => !selectedVehicles.some(selected => selected.id === result.id)
            );
            setSearchResults(newResults);
        } catch (err) {
            console.error("Error searching for unlinked vehicles:", err);
        } finally {
            setIsSearching(false);
        }
    };

    const handleSelectVehicle = (vehicle) => {
        setSelectedVehicles(prev => [...prev, vehicle]);
        setSearchTerm('');
        setSearchResults([]);
    };

    const handleRemoveVehicle = (vehicleId) => {
        setSelectedVehicles(prev => prev.filter(v => v.id !== vehicleId));
    };

    const handleSave = async () => {
        if (selectedVehicles.length === 0) {
            setError('연결할 차량을 선택해주세요.');
            return;
        }
        setError('');
        setIsSaving(true);
        try {
            const vehicleIds = selectedVehicles.map(v => v.id);
            await api.post(`/customers/${customerId}/link-vehicles`, { vehicleIds });
            onSuccess();
            handleClose();
        } catch (err) {
            setError('차량 연결에 실패했습니다.');
            console.error("Failed to link vehicles:", err);
        } finally {
            setIsSaving(false);
        }
    };

    const handleClose = () => {
        setSearchTerm('');
        setSearchResults([]);
        setSelectedVehicles([]);
        setError('');
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>기존 차량 연결</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form.Group className="mb-3">
                    <Form.Label>차량번호로 검색</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="연결할 차량의 번호 입력..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                    {isSearching && <Spinner size="sm" className="mt-2" />}
                    {searchResults.length > 0 && (
                        <ListGroup className="mt-2">
                            {searchResults.map(v => (
                                <ListGroup.Item action key={v.id} onClick={() => handleSelectVehicle(v)}>
                                    {v.plateNumber}
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    )}
                </Form.Group>
                <hr />
                <h6>연결할 차량 목록</h6>
                <ListGroup>
                    {selectedVehicles.length > 0 ? selectedVehicles.map(v => (
                        <ListGroup.Item key={v.id} className="d-flex justify-content-between align-items-center">
                            {v.plateNumber}
                            <Button variant="danger" size="sm" onClick={() => handleRemoveVehicle(v.id)}>X</Button>
                        </ListGroup.Item>
                    )) : (
                        <ListGroup.Item disabled>선택된 차량이 없습니다.</ListGroup.Item>
                    )}
                </ListGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    취소
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={isSaving || selectedVehicles.length === 0}>
                    {isSaving ? <Spinner as="span" size="sm" /> : `(${selectedVehicles.length})대 차량 연결`}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default LinkVehicleModal;
